import {defaultUserTypeDescription} from "../constants";
import {type TypeGroupPair, type Configuration, type Value} from "../types";

export const hasConfigurationChanged = (current: Configuration, original: Configuration) => {
  if (!original) {
    return false;
  }

  for (const key in current) {
    if (shouldSkip(key, current, original)) {
      continue;
    }

    if (
      (typeof current[key] === "string" ? current[key].trim() : current[key]) !== original[key] &&
      !(
        typeof current[key] === "string" &&
        current[key].trim() === "" &&
        original[key] === undefined
      )
    ) {
      return true;
    }
  }

  return false;
};

const shouldSkip = (
  key: string,
  currentValues: Configuration,
  originalConfiguration: Configuration
) => {
  return (
    isUnchangedTypeGroupEntry(key, currentValues, originalConfiguration) ||
    key === "id" ||
    isEmptyFile(key, currentValues)
  );
};

const isUnchangedTypeGroupEntry = (
  key: string,
  currentValues: Configuration,
  originalConfiguration: Configuration
): boolean => key.startsWith("type_") && !currentValues[key] && !originalConfiguration[key];

const isEmptyFile = (key: string, currentValues: Configuration): boolean =>
  key === "file" && !(currentValues?.file?.length > 0);

export const getUnavailableTypeGroupPairs = (
  allConfigurations: Configuration[],
  configuration: Configuration
): TypeGroupPair[] =>
  allConfigurations
    .flatMap(configuration => configuration.typeGroupPairs)
    .filter(
      pair =>
        !configuration?.typeGroupPairs.find(
          configurationPair =>
            configurationPair.groupId === pair.groupId && configurationPair.typeId === pair.typeId
        )
    );

export const getOtherUserGroups = (configuration: Configuration, userGroups: Value[]): Value[] =>
  configuration?.typeGroupPairs
    .filter(pair => !userGroups.find(group => group.code === pair.groupId))
    ?.map(pair => ({code: pair.groupId, description: undefined})) ?? [];

export const getOtherUserTypes = (configuration: Configuration, userTypes: Value[]): Value[] =>
  configuration?.typeGroupPairs
    .filter(pair => !userTypes.find(type => type.code === pair.typeId))
    ?.map(pair => ({code: pair.typeId, description: defaultUserTypeDescription(pair.typeId)})) ??
  [];
